///TODO: MOVE TO ENV FILE
export const allowedOrigins = [
  "http://localhost:3000",
  "http://localhost:3001",
  "https://ekon-v2-web-dev-ghbyb3brdmhvfee9.southeastasia-01.azurewebsites.net",
  "https://bps-dev-web-cjhdeqb4chg7fvdp.australiaeast-01.azurewebsites.net",
  "https://bps-test-web-g6becgb0c3ejc0h0.eastasia-01.azurewebsites.net",
  "https://hih-dev-web.azurewebsites.net",
  "https://konsulta.azurewebsites.net",
  "https://konsulta-api.azurewebsites.net",
  "https://bizbox-profiling.azurewebsites.net",
  "https://bps-prod-api-faenfccygnc5hbat.southeastasia-01.azurewebsites.net",
  "https://ekon-v2-web-test-fvaeg2f9h8g3g7et.southeastasia-01.azurewebsites.net",
  "https://ekon-v2-api-test.azurewebsites.net",
  "http://192.168.222.111:3000",
  "http://192.168.222.111:50343",
  "https://beacon-eclaims-dev.azurewebsites.net",
  "https://beacon-eclaims-api-dev.azurewebsites.net",
  "https://localhost:5078",
  "https://localhost:7023",
  "http://localhost:5173",
  "https://localhost:5173",
  "https://bizbox-analytics-test-web.azurewebsites.net",
  "https://bizbox-analytics-test-web-e4dmbuf3bqccfcc3.southeastasia-01.azurewebsites.net",
  "https://bcp-web.whiteflower-17753126.southeastasia.azurecontainerapps.io",
  "https://bucketone-projex-web.azurewebsites.net",
  "https://bizbox-crm-web-dev.azurewebsites.net",
  "https://bizbox-crm-api-dev.azurewebsites.net",
  "https://bizbox-crm-web-prod.azurewebsites.net",
  "https://bizbox-desk-web-dev-gef7ewe4hagwgkcj.southeastasia-01.azurewebsites.net",
  "https://support.bizbox.ph",
  "https://bizbox-desk-api-dev-hscqgqeyfwaudrfb.southeastasia-01.azurewebsites.net",
  "https://blue-flower-038b55200.7.azurestaticapps.net",
  "https://bizbox-desk-prod-g0dpdgd7fwakefg4.southeastasia-01.azurewebsites.net",
  "https://bizbox-desk-api-prod-ceevf4atd9g2gbf5.southeastasia-01.azurewebsites.net",
  "https://bizbox-desk-gateway-prod-hkgsf2h6aycyetad.southeastasia-01.azurewebsites.net",
  "https://bucketone-web-gwf8bnasgchpf2a8.southeastasia-01.azurewebsites.net",
  "https://bucketone-api-prod-bqgnatfpeddsddbe.southeastasia-01.azurewebsites.net",
  "https://bpm-web-dev-cga0chhfc3evfga5.southeastasia-01.azurewebsites.net",
  "https://bpm-api-dev-bvbtb9e8g0cdavar.southeastasia-01.azurewebsites.net",
  "https://bpm-aggthmh4a0g4exd3.southeastasia-01.azurewebsites.net",
  "https://bpm-api-emf9d9e6eycvaxhr.southeastasia-01.azurewebsites.net"
];
